import { ComponentMeta, ComponentStory } from "@storybook/react";
import React from "react";
import { SearchIcon } from "lucide-react";
import TextInput from "./TextInput";

type Story = ComponentStory<typeof TextInput>;

const commonArgs: React.ComponentProps<typeof TextInput> = {
    placeholder: "Placeholder",
    defaultValue: "Text",
    disabled: false,
    helperText: "",
    label: "",
    leadingEnhancement: "",
    trailingEnhancement: ""
};

export default {
    title: "Form components/TextInput",
    component: TextInput,
    args: commonArgs
} as ComponentMeta<typeof TextInput>;

const Template: Story = args => (
    <div style={{ width: "360px" }}>
        <TextInput {...args} />
    </div>
);

export const Default = Template.bind({});

export const Placeholder = Template.bind({});
Placeholder.args = {
    defaultValue: undefined
};

export const Focus = Template.bind({});
Focus.args = {
    autoFocus: true
};

export const WithError = Template.bind({});
WithError.args = {
    error: (
        <>
            Available quantity of Product 1 at BER2: <strong>2000</strong>
        </>
    )
};

export const WithErrorAsBoolean = Template.bind({});
WithErrorAsBoolean.args = {
    error: true
};

export const Disabled = Template.bind({});
Disabled.args = {
    disabled: true
};

export const WithField = Template.bind({});
WithField.args = {
    label: "Leading label",
    helperText: "Helper text"
};

export const WithIcon = Template.bind({});
WithIcon.args = {
    icon: <SearchIcon />,
    placeholder: "Search",
    defaultValue: ""
};

export const WithLeadingEnhancement = Template.bind({});
WithLeadingEnhancement.args = {
    leadingEnhancement: "Label"
};

export const WithTrailingEnhancement = Template.bind({});
WithTrailingEnhancement.args = {
    trailingEnhancement: "Label"
};
